import type { TextStyle_TextAlignment } from './../../ricos-schema/legacy/wix/rich_content/v1';

import { isTextAlignmentStyle } from './is-text-alignment-style';

export const getEnumByStyle = (
  textAlign: string | undefined,
  fallback: TextStyle_TextAlignment
): TextStyle_TextAlignment => {
  const textAlignUpperCase = textAlign?.toUpperCase();
  if (!isTextAlignmentStyle(textAlignUpperCase)) {
    return fallback;
  }

  return textAlignUpperCase;
};
